import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as icons from '@material-ui/icons';
import { ComponentType } from 'react';

interface IItem {
  to: string;
  title: string;
  icon: ComponentType<SvgIconProps>;
}

const menuItems = (role: "root" | "sales"): IItem[][] => {
  if (role === "root") {
    return [
      [
        {
          to: '/',
          title: 'Dashboard',
          icon: icons.Dashboard,
        },
        {
          to: '/jobs',
          title: 'Jobs',
          icon: icons.Work,
        },
        {
          to: '/users',
          title: 'Users',
          icon: icons.Person,
        },
        {
          to: '/reviews',
          title: 'Reviews',
          icon: icons.Star,
        },
        {
          to: 'feedback',
          title: 'Feedback',
          icon: icons.Feedback,
        },
      ],
    ];
  } else if (role === "sales") {
    return [
      [
        {
          to: '/',
          title: 'Dashboard',
          icon: icons.Dashboard,
        },
        {
          to: '/jobs',
          title: 'Jobs',
          icon: icons.Work,
        },
        {
          to: '/users',
          title: 'Users',
          icon: icons.Person,
        },
      ],
    ];
  }
  return [];
};

export default menuItems;



// WEBPACK FOOTER //
// ./src/containers/Admin/menuItems.ts